export enum MutationTypes {
  REGISTRATION_CONTACT_FORM_SENDING = "REGISTRATION_CONTACT_FORM_SENDING",
  REGISTRATION_CONTACT_FORM_SENT = "REGISTRATION_CONTACT_FORM_SENT",
  REGISTRATION_COMPANY_LOADING = "REGISTRATION_COMPANY_LOADING",
  REGISTRATION_COMPANY_LOADED = "REGISTRATION_COMPANY_LOADED",
  REGISTRATION_STUDENT_LOADING = "REGISTRATION_STUDENT_LOADING",
  REGISTRATION_STUDENT_LOADED = "REGISTRATION_STUDENT_LOADED",
  REGISTRATION_ACTIVATION_LOADING = "REGISTRATION_ACTIVATION_LOADING",
  REGISTRATION_ACTIVATION_LOADED = "REGISTRATION_ACTIVATION_LOADED",
}
